import { Image, Spacing, Text } from '@billy/design-system'
import { css } from '@emotion/core'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { SpecificState } from '../../../types/reduxSaga-deprecated'
import { getBankLogoUrl } from '../utils'
import * as Styled from './styles'

export const BankLogo = () => {
  const { t } = useTranslation()
  const [imageUrl, setImageUrl] = useState<string | null>(null)
  const account = useSelector((state: SpecificState) => state.app.account)

  useEffect(() => {
    ;(async () => {
      setImageUrl(!account?.bankId ? null : await getBankLogoUrl(account.bankId))
    })()
  }, [account])

  if (imageUrl) {
    return (
      <Styled.BankLogoWrapper>
        <div style={{ height: '35px', marginBottom: Spacing.S12 }}>
          <Image
            src={imageUrl}
            objectFit="contain"
            css={css`
              filter: grayscale(1);
            `}
          />
        </div>
      </Styled.BankLogoWrapper>
    )
  }

  return (
    <Styled.BankLogoWrapper>
      <Text
        css={css`
          font-size: 24px;
          text-align: center;
          margin-bottom: ${Spacing.S16};
        `}
      >
        {t('bankreconciliation.bank.your_bank')}
      </Text>
    </Styled.BankLogoWrapper>
  )
}
